import React from 'react'
import Header from './component/IndexPageFA/Header'
import AddressAndCommunication from './component/IndexPageFA/AddressAndCommunication'
import Footer from './component/IndexPageFA/Footer'
import ShowAllProducts from './component/ProductsPageFA/ShowAllProducts'


const ProductsFA = () => {
  return (
    <div>
        <Header page={"page"}> 
          <div className="titleFA">
          گروه تجارت پهلوان مقدم
          </div>
        </Header>
        <ShowAllProducts />
        <AddressAndCommunication />
        <Footer />
    </div>
  )
}

export default ProductsFA
